// https://vuex.vuejs.org/en/actions.html
import axios from 'axios'

// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  login ({ commit }, userData) {
    return new Promise((resolve, reject) => {
      commit('auth_request')
        axios.get('sanctum/csrf-cookie').then(response => {
            axios.post('/api/login', { email: userData.username, password: userData.password, remember: userData.remember })
                .then(response => {
                    var userInfo = JSON.stringify(response.data)
                    var user = userInfo
                    localStorage.setItem('user', user)
                    localStorage.setItem('userInfo', userInfo)
                    // mutation to change state properties to the values passed along
                    commit('auth_success', { user })
                    resolve(response)
                })
                .catch(err => {
                    console.log('login error')
                    commit('auth_error')
                    localStorage.removeItem('userInfo')
                    localStorage.removeItem('user')
                    reject(err)
                })
        })
    })
  },

  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('logout')
        axios.post('api/logout')
            .then(() => {
                document.cookie = 'blahblahblah_session=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.blahblahblahapp.io;'

                localStorage.clear()
                sessionStorage.clear()
                }
            )

      resolve()
    })
  },
  getTableList ({ commit }, tableName) {
    this.$http.get(`/${tableName}`)
      .then(response => {
        console.log(response)
        let tableList = response.data.Keys
        commit('setTableList', { tableList })
      })
      .catch(error => console.log(error))
  },
  updateTableItem ({ commit }, tableData) {
    return new Promise((resolve, reject) => {
      let httpmethod = tableData.method
      axios({ url: `/${tableData.endpoint}`, method: httpmethod, data: tableData.tableItem })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  }

  // autoRefreshToken ({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     setInterval(function () {
  //       // code goes here that will be run every 20 minutes.
  //       axios.get('/refresh')
  //         .then(response => {
  //           const token = response.data.access_token
  //           localStorage.setItem('token', token)
  //           axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  //           commit('auth_success', { token })
  //           resolve(response)
  //         })
  //         .catch(error => {
  //           console.log('refresh token error')
  //           console.log(error)
  //           reject(error)
  //         })
  //     }, 1200000)
  //   }
  //   )
  // },

}
